export const pagetypeConstants = {
  PAGETYPE_LIST_REQUEST: "PAGETYPE_LIST_REQUEST",
  PAGETYPE_LIST_SUCCESS: "PAGETYPE_LIST_SUCCESS",
  PAGETYPE_LIST_FAILURE: "PAGETYPE_LIST_FAILURE",

  PAGETYPE_TREE_REQUEST: "PAGETYPE_TREE_REQUEST",
  PAGETYPE_TREE_SUCCESS: "PAGETYPE_TREE_SUCCESS",
  PAGETYPE_TREE_FAILURE: "PAGETYPE_TREE_FAILURE",

  PAGETYPE_GROUP_LIST_REQUEST: "PAGETYPE_GROUP_LIST_REQUEST",
  PAGETYPE_GROUP_LIST_SUCCESS: "PAGETYPE_GROUP_LIST_SUCCESS",
  PAGETYPE_GROUP_LIST_FAILURE: "PAGETYPE_GROUP_LIST_FAILURE",

  PAGETYPE_FOR_GROUP_LIST_REQUEST: "PAGETYPE_FOR_GROUP_LIST_REQUEST",
  PAGETYPE_FOR_GROUP_LIST_SUCCESS: "PAGETYPE_FOR_GROUP_LIST_SUCCESS",
  PAGETYPE_FOR_GROUP_LIST_FAILURE: "PAGETYPE_FOR_GROUP_LIST_FAILURE",

  PAGETYPE_FOR_GROUP_ADD_REQUEST: "PAGETYPE_FOR_GROUP_ADD_REQUEST",
  PAGETYPE_FOR_GROUP_ADD_SUCCESS: "PAGETYPE_FOR_GROUP_ADD_SUCCESS",
  PAGETYPE_FOR_GROUP_ADD_FAILURE: "PAGETYPE_FOR_GROUP_ADD_FAILURE",

  PAGETYPE_FOR_GROUP_REMOVE_REQUEST: "PAGETYPE_FOR_GROUP_REMOVE_REQUEST",
  PAGETYPE_FOR_GROUP_REMOVE_SUCCESS: "PAGETYPE_FOR_GROUP_REMOVE_SUCCESS",
  PAGETYPE_FOR_GROUP_REMOVE_FAILURE: "PAGETYPE_FOR_GROUP_REMOVE_FAILURE",

  PAGETYPE_CREATE_GROUP_REQUEST: "PAGETYPE_CREATE_GROUP_REQUEST",
  PAGETYPE_CREATE_GROUP_SUCCESS: "PAGETYPE_CREATE_GROUP_SUCCESS",
  PAGETYPE_CREATE_GROUP_FAILURE: "PAGETYPE_CREATE_GROUP_FAILURE",

  PAGETYPE_CREATE_REQUEST: "PAGETYPE_CREATE_REQUEST",
  PAGETYPE_CREATE_SUCCESS: "PAGETYPE_CREATE_SUCCESS",
  PAGETYPE_CREATE_FAILURE: "PAGETYPE_CREATE_FAILURE",

  PAGETYPE_UPDATE_REQUEST: "PAGETYPE_UPDATE_REQUEST",
  PAGETYPE_UPDATE_SUCCESS: "PAGETYPE_UPDATE_SUCCESS",
  PAGETYPE_UPDATE_FAILURE: "PAGETYPE_UPDATE_FAILURE",

  PAGETYPE_UNGROUPED_ID_REQUEST: "PAGETYPE_UNGROUPED_ID_REQUEST",
  PAGETYPE_UNGROUPED_ID_SUCCESS: "PAGETYPE_UNGROUPED_ID_SUCCESS",
  PAGETYPE_UNGROUPED_ID_FAILURE: "PAGETYPE_UNGROUPED_ID_FAILURE",

  PAGETYPE_UNCLASSIFIED_ID_REQUEST: "PAGETYPE_UNCLASSIFIED_ID_REQUEST",
  PAGETYPE_UNCLASSIFIED_ID_SUCCESS: "PAGETYPE_UNCLASSIFIED_ID_SUCCESS",
  PAGETYPE_UNCLASSIFIED_ID_FAILURE: "PAGETYPE_UNCLASSIFIED_ID_FAILURE",

  PAGETYPE_INSPECTION_REQUEST: "PAGETYPE_INSPECTION_REQUEST",
  PAGETYPE_INSPECTION_SUCCESS: "PAGETYPE_INSPECTION_SUCCESS",
  PAGETYPE_INSPECTION_FAILURE: "PAGETYPE_INSPECTION_FAILURE",

  PAGETYPE_SET_CURRENT_PAGETYPE: "PAGETYPE_SET_CURRENT_PAGETYPE",
};
